import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

class PortConnections extends React.Component {
  static propTypes = {
    tcpTls: PropTypes.bool,
    tcpPlainText: PropTypes.bool,
    udpPlainText: PropTypes.bool,
    editMode: PropTypes.bool.isRequired,
  };

  state = {
    isTokenAuth: PT.port.tokenAuth
  };

  onTokenAuthToggle = () => {
    this.setState((prevState) => {
      return { isTokenAuth: !prevState.isTokenAuth };
    });
  }

  render() {
    const { isTokenAuth } = this.state;
    const { tcpTls, tcpPlainText, udpPlainText, editMode } = this.props;

    return (
      <div className="port-connections">
        <div className='connection-option without-port'>
          <p className="inline">
            <label>
              <input
                className="radio"
                name="port[token_auth]"
                type="radio"
                value="1"
                checked={isTokenAuth}
                disabled={editMode}
                onChange={this.onTokenAuthToggle}
              /> Token
            </label>
          </p>
          <p className="subtext">
            Token-based authentication supports HTTPS.
          </p>
        </div>
        <div className='connection-option with-port'>
          <p className="inline">
            <label>
              <input
                className="radio"
                name="port[token_auth]"
                type="radio"
                value="0"
                checked={!isTokenAuth}
                onChange={this.onTokenAuthToggle}
              /> Port
            </label>
          </p>
          <div className="grid flex with-port-options">
            <div className="grid-cell">
              TCP:
              <ul>
                <li>
                  <p className="inline checkbox">
                    <label>
                      <input name="port[tcp_tls]" type="hidden" value="0" />
                      <input defaultChecked={tcpTls} disabled={isTokenAuth} className="checkbox" id="port_tcp_tls" name="port[tcp_tls]" type="checkbox" value="1" />
                      TLS encryption
                    </label>
                  </p>
                </li>
                <li>
                  <p className="inline checkbox">
                    <label>
                      <input name="port[tcp_plain_text]" type="hidden" value="0" />
                      <input defaultChecked={tcpPlainText} className="checkbox" disabled={isTokenAuth} id="port_tcp_plain_text" name="port[tcp_plain_text]" type="checkbox" value="1" />
                      Plain text
                    </label>
                  </p>
                </li>
              </ul>
            </div>
            <div className="grid-cell">
              UDP:
              <ul>
                <li>
                  <p className="inline checkbox">
                    <label>
                      <input name="port[udp_plain_text]" type="hidden" value="0" />
                      <input defaultChecked={udpPlainText} disabled={isTokenAuth} className="checkbox" id="port_udp_plain_text" name="port[udp_plain_text]" type="checkbox" value="1" />
                      Plain text
                    </label>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

$(function() {
  const container = document.getElementById('port-connections');
  if(container)  {
    ReactDOM.render(
      <PortConnections
        tcpTls={PT.port.tcp_tls}
        tcpPlainText={PT.port.tcp_plain_text}
        udpPlainText={PT.port.udp_plain_text}
        editMode={PT.port.editMode}
      />,
      container
    );
  }
});
